export const fetchData = async (
  url: string,
  method: RequestInit['method'],
  options: Omit<RequestInit, 'method'>
): Promise<Response> =>
  fetch(url, {
    method,
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
